module.exports = __webpack_public_path__ + "media/application/images/icons/info-f31f1e5a5be0731e6842cfcae77316c8.svg";